export const messages = {
  en: {
    productCategory: {
      queryCondition: 'Query Conditions',
      inputName: 'Please enter name',
      selectShowStatus: 'Please select display status',
      selectGroup: 'Please select group category',
      productGroup: 'Product Group',
      categoryId: 'Category ID',
      categoryName: 'Category Name',
      groupType: 'Group Type',
      showOrder: 'Display Order',
      isShow: 'Is Displayed',
      createTime: 'Create Time',
      addTitle: 'Add Product Category',
      editTitle: 'Edit Product Category',
      nameRequired: 'Category name is required',
      nameMaxLength: 'Category name cannot exceed 100 characters',
      namePlaceholder: 'Required, please enter category name',
      orderRequired: 'Display order is required',
      orderNumber: 'Display order must be a number',
      orderPlaceholder: 'Required, please enter display order',
      showRequired: 'Display status is required',
      showPlaceholder: 'Required, please select display status',
      groupRequired: 'Group category is required',
      groupPlaceholder: 'Required, please select group category',
      confirmDelete: 'Are you sure to delete this product category?',
      normalGoods: 'Regular Goods',
      specialGoods: 'Special Goods',
      pointGoods: 'Points Goods'
    }
  },
  zh: {
    productCategory: {
      queryCondition: '查询条件',
      inputName: '请输入名称',
      selectShowStatus: '请选择是否显示',
      selectGroup: '请选择分组目录',
      productGroup: '商品分组',
      categoryId: '分类编号',
      categoryName: '分类名称',
      groupType: '分组目录',
      showOrder: '显示序号',
      isShow: '是否显示',
      createTime: '创建时间',
      addTitle: '添加商品分类',
      editTitle: '修改商品分类',
      nameRequired: '分类名称不能为空',
      nameMaxLength: '分类名称不能超过100位',
      namePlaceholder: '必填，请填写分类名称',
      orderRequired: '显示序号不能为空',
      orderNumber: '显示序号必须为数字',
      orderPlaceholder: '必填，请填写显示序号',
      showRequired: '是否显示不能为空',
      showPlaceholder: '必填，请选择是否显示',
      groupRequired: '分组目录不能为空',
      groupPlaceholder: '必填，请选择分组目录',
      confirmDelete: '确定删除该商品分类吗？',
      normalGoods: '常规商品',
      specialGoods: '非常规商品',
      pointGoods: '积分商品'
    }
  }
}